import React from "react";
import AnnouncementImg from "../../Icons/AnnouncementBg.svg";
import { ReactComponent as BellIcon } from "../../Icons/BellIcon.svg";
import { Box, Grid, Stack, Typography, useMediaQuery } from "@mui/material";
import { AnnounceMentList } from "../../Data";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

export default function Announcement({ announcementData }) {
  const isMobile = useMediaQuery("(max-width:600px)");
  const navigate = useNavigate()
  const language = useSelector((state) => state.language.language)
  const { t } = useTranslation()
  const styles = useSelector((state) => state.styles)

  console.log(AnnounceMentList)

  console.log(announcementData)
  return (
    <Box sx={{ mt : {lg : '160px'}}}>
      <Stack alignItems="center" sx={{ }}>
        <Typography
          p={2}
          width="fit-content"
          color="primary"
          border="1px solid #27BAC4"
          padding="10px 50px"
          borderRadius="50px"
          letterSpacing="1.1px"
          sx={{...styles.h2}}
        >
          {t("ANNOUNCEMENTS")}
        </Typography>
      </Stack>
      <Grid
        
   
        gap={10}
        display="flex"
        justifyContent="center"
        container
        sx={{ backgroundColor: "#EFF4FC", mt : '40px' }}
      >
      <Grid xs={12} lg={5} sx={{ mt : '50px', mb : {lg : '25px', xs : '0px'}}}>
          <Box sx={{width : {xs : '100%'}}} component="img" src={AnnouncementImg}></Box>
          {/* <img src={AnnouncementImg} /> */}
        </Grid>
        <Grid
          display="flex"
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
          xs={12}
          lg={5}
         sx={{mt : {lg : '50px', xs : '0px', md : '50px'}, mb : '25px'}}
        >
          {/* <Stack> */}
          <Stack
            sx={{
              backgroundColor: "white",
              // border: "0.5px solid #27BAC4",
              borderRadius: "20px",
              height: "60vh",
              width: {xs : '90%', lg : '600px'},
              // background: "linear-gradient(to top, white, transparent)",
              zIndex: 5,
              boxShadow : '0px 0px 10px #00000010'
            }}
          >
            <Typography
              p={2}
              fontSize="24px"
              color="primary"
              textAlign="start"
              borderBottom="0.5px solid #27BAC4"
            >
              {t("Announcements")}
            </Typography>
            <Stack
              rowGap="20px"
              p={{ xs: 1, sm: 1, md: 2, lg: 3, xl: 3 }}
              sx={{
                overflowY: "scroll",
                overflowX: "scroll",
                "&::-webkit-scrollbar": { display: "none" },
              }}
            >
              {announcementData?.map((itm, index) => (
                <>
                  <Stack
                    direction={{
                      xs: "column",
                      sm: "column",
                      md: "column",
                      lg: "column",
                      xl: "column",
                    }}
                    justifyContent="space-between"
                    height={{
                      xs: "auto",
                      sm: "auto",
                      md: "auto",
                      lg: "auto",
                      xl: "auto",
                    }}
                    
                    sx={{p : {xs : 0, sm : 2, lg : 0}}}
                  >
                    <Stack direction="row" sx={{}} columnGap={{xs : '10px', sm : '40px', lg : '10px'}} alignItems="center">
                      <Box
                        sx={{
                          width: {xs : '45px', sm : '70px', lg : '45px'},
                          height: {xs : '45px', sm : '70px', lg : '45px'},
                          borderRadius: "100px",
                          backgroundColor: "button",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <BellIcon width='100%' />
                      </Box>
                      <Box
                        display="flex"
                        flexDirection="column"
                        textAlign="start"
                        sx={{ height : 'auto', width : '80%'}}
                      >
                        <Typography sx={{...styles.subheading}} color="text_blue">
                          {itm?.title?.[language]}
                        </Typography>
                        <Typography sx={{...styles.subheadingDescription}} color="text_blue">
                          {itm?.subtitle?.[language]}
                        </Typography>
                      </Box>
                    </Stack>
                    <Stack
                      alignItems={{ xs: "start", lg: "start" }}
                      sx={{ px: { xs: "54px", sm : '110px',lg: "54px" }, pt : '4px' }}
                    >
                      <Typography sx={{...styles.subTimeDate}} color="#606060">
                        {itm?.time}
                      </Typography>
                      <Typography sx={{...styles.subTimeDate}} color="#606060">
                        {itm?.date}
                      </Typography>
                    </Stack>
                  </Stack>
                  {/* </>)} */}
                </>
              ))}
            </Stack>
          </Stack>

          <Box
            sx={{
              display: "flex",
              flexWrap: "wrap",
              justifyContent: {xs : 'center', lg : 'space-between'},
              rowGap: {xs : '15px', sm : 3, lg : '15px'},
              columnGap: {
                xs: "5px",
                sm: 3.5,
                md: "20px",
                lg: "10px",
                xl: "15px",
              },
              px: { xs: 0.95, sm: 5.5, md: 2.5, lg: 2.5 },
              mt: {xs : 3, sm : 8, lg : 3},
              pb: 5,
            }}
          >
            
            {AnnounceMentList.map((item, index) => (
              <Box
                key={item.id}
                onClick={() => navigate(item?.navigate)}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  ':hover' : {
                    cursor : 'pointer',
                  },
                  gap : 1,
                  justifyContent: "space-between",
                  border: "0.5px solid #27BAC4",
                  backgroundColor: "#DDF1F0",
                  p: { xs: 1, sm: 1, md: 2, lg: 2 },
                  borderRadius: "20px",
                  width: { xs: "290px", sm: "200px", md: "220px", lg: "260px" },
                }}
              >
                {/* <Box component="img" sx={{backgroundColor : '#27BAC4', p:1, borderRadius : '10px'}} src={item?.icon}></Box> */}
                <Box sx={{backgroundColor: "#27BAC4", width : '50px', height : '50px', display : 'flex', justifyContent : 'center', alignItems : 'center', borderRadius : '100%'}}>
                {typeof item.icon === "string" ? (
                  <Box
                    component="img"
                    sx={{
                      // backgroundColor: "#27BAC4",
                      borderRadius: "10px",
                      width : '24px',
                      height : '24px'
                    }}
                    src={item.icon}
                  />
                ) : (
                  <item.icon
                    sx={{
                      backgroundColor: "#27BAC4",
                      fontSize: "3rem",
                      p: 1,
                      borderRadius: "10px",
                      color: "white",
                    }}
                  />
                )}
                </Box>
                <Box sx={{width : '70%', display :'flex', gap : 2, justifyContent : 'space-between', alignItems : 'center'}}>
                <Typography sx={{ color: "#1A2461", fontSize : '14px', fontWeight : 700 }}>
                  <span dangerouslySetInnerHTML={{ __html: t(item?.name) }} />
                </Typography>
                <Box component="img" src={item?.arrow}></Box>
                </Box>
              </Box>
            ))}
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
}
